const isElementInNewRowWrapper = (element) => {
  const newRowWrapper = document.querySelector(
    '[data-add-new-row-wrapper="true"]'
  );
  if ((newRowWrapper == null ? void 0 : newRowWrapper.contains(element)) || (element == null ? void 0 : element.getAttribute("data-add-new-row-wrapper")) === "true") {
    return true;
  }
  return false;
};
const isElementCloseAddNewRow = (element) => {
  const closeButton = document.querySelector('[data-close-add-new-row="true"]');
  if ((closeButton == null ? void 0 : closeButton.contains(element)) || (element == null ? void 0 : element.getAttribute("data-close-add-new-row")) === "true") {
    return true;
  }
  return false;
};
export {
  isElementCloseAddNewRow,
  isElementInNewRowWrapper
};
